export enum UserStatusesEnum {
  CREATED = 'CREATED',
  ACCEPTED = 'ACCEPTED',
  DISABLED = 'DISABLED',
}
